/* global ALGOLIA_CREDENTIALS */
import React, { useState } from "react";
import PropTypes from "prop-types";
import ReactDOM from "react-dom/client";
import { InstantSearch, Configure, useHits } from "react-instantsearch";
import { liteClient as algoliasearch } from "algoliasearch/lite";
import Modal from "./configurator/modal";
// Algolia credentials
const credentials = ALGOLIA_CREDENTIALS || {};
const searchClient = algoliasearch(credentials.appId, credentials.apiKey);

function Component() {
  const [modalOpen, setModalOpen] = useState(false);
  const { items } = useHits();

  const hit = items?.[0];
  if (!hit) return null;

  const toggleModal = () => setModalOpen(prev => !prev);

  return (
    <div className="soft--ends container">
      <div className="configurator-result configurator-result--block">
        <div className="configurator-result__body">
          <h5 className="configurator-result__sub-heading">Product code</h5>
          <h4 className="configurator-result__heading">
            {hit.ostendoModelCode}
          </h4>
        </div>
        <a className="btn" onClick={toggleModal}>  Enquire<span className="hide--palm"> Now</span> </a>
        <a  href={`${window.location.origin}/products/pdf/${hit.objectID}`} className="configurator__download" target="_blank"  rel="noopener noreferrer" >
          <svg> <use xlinkHref="#datasheet-icon" /> </svg>
          <span>Download datasheet</span>
        </a>
      </div>

      <Modal
        isOpen={modalOpen}
        toggleModal={toggleModal}
        hit={{
          ...hit,
          ostendoItemCode: hit.ostendoModelCode,
          ostendoProductImages: Object.keys(hit.thumbnails || {}).length
            ? [{ crop210x210: hit.thumbnails.White }]
            : [],
        }}
      />
    </div>
  );
}
Component.propTypes = {
  hit: PropTypes.shape({
    image: PropTypes.arrayOf(PropTypes.string),
    ostendoItemCode: PropTypes.string,
    title: PropTypes.string,
  }),
};
// Mount app
const rootElement = document.querySelector(".js-product-enquiry");

if (rootElement && credentials) {
  const modelName = rootElement.getAttribute("data-model-name") || "";
  window.showPhotometricButton = rootElement.getAttribute("data-show-photometric-button");
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <InstantSearch
      searchClient={searchClient}
      indexName={credentials.indexName || "products"}
    >
      <Configure filters={`enabled:"true" AND ostendoModelName:"${modelName}"`}  />
      <Component />
    </InstantSearch>
  );
}